import React, { useEffect, useState } from 'react';
import { BaseUrl } from './BaseUrl';
import { AssetsUrl } from './BaseUrl';

export default function Work_Cafes() {
 const [banner_img, setbanner_img] = useState([]);
   const [baseUrl] = useState(BaseUrl);
   const [assetsUrl] = useState(AssetsUrl);

 useEffect(() => {
  fetch(`${baseUrl}/getBannerById/11`)
      .then((resp) => resp.json())
      .then((result) => { 
        setbanner_img(result.banner_images); 
      })
      .catch((err) => console.error("Error fetching banner images:", err));
}, []);

  return (
    <>
<div className="container-fluid slider_top">
          <div className="row">
            <div className="col-md-4 col-12">
              <img
                src="./assets/images/banner/work_one.jpg"
                alt=""
                className="bnr_img_30 padding_set"
              />
            </div>
            <div className="col-md-4 col-12">
              <img
                src="./assets/images/banner/work_two.jpg"
                alt=""
                className="bnr_img_30 padding_set mobile_hide"
              />
            </div>
            <div className="col-md-4 col-12">
              <img
                src="./assets/images/banner/work_three.jpg"
                alt=""
                className="bnr_img_30 padding_set mobile_hide"
              />
            </div>
          </div>
        </div>

      

      <section className="section-reservation-form padding-bottom-100">
        <div className="container">
        <div class="swin-sc swin-sc-title style-2">

<h3 class="title"><span>WORK CAFES</span></h3>
<p class="cafe-text text_justify">Work cafés have been aligned with new global standards embracing
                design elements and collaborative seating to create a unique
                space for informal meetings and gatherings. </p>
  </div>

          <div className="reservation-form  ">
          <div class="d-flex justify-content-center">
                <div class="col-md-8 col-md-offset-2">
                  <h4 class="service-title text-center">What Do Work Cafes Offer:</h4>
                  <p class="cafe-text text-center">Our amenities aim to provide the best employee experience across our cafes and pantry areas</p>
                </div>
              </div>
              
            <div className="row">
              <div className="col-md-12">
                <div className="box-shadow ">
                  <div className="work_sustain">
                    <img src="./assets/images/icon/Beverage-machine.png" alt="" />
                    <p className="sustain_new">Beverage Machines</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">Our beverage machines offer a wide variety of both hot
                    and cold drinks free for employees to enjoy.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row ">
              <div className="col-md-6">
                <div className="box-shadow box-equal">
                  <div className="work_sustain hydration ">
                    <img src="./assets/images/icon/filter-water.png" alt="" />
                    <p className="sustain_new ">Filtered Water</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">Clean, filtered water is available hot or cold.</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="box-shadow box-equal ">
                  <div className="work_sustain ">
                    <img src="./assets/images/icon/microwave.png" alt="" />
                    <p className="sustain_new ">Microwave Oven</p>
                  </div>
                  <div>
                  <p className="sustain_new_para microwave">Provided for reheating home-cooked meals using
                  microwave-safe containers.</p>
                    
                  </div>
                </div>
              </div>

              <div className="col-md-6 ">
                <div className="box-shadow box-equal " >
                  <div className="work_sustain refrigerator" style={{paddingBottom:'20px'}}>
                    <img src="./assets/images/icon/fridge.png" alt="" />
                    <p className="sustain_new">Chillers</p>
                  </div>
                  <div>
                  <p className="sustain_new_para ">For home-brought food and drinks, chillers are available
                  for safe storage.</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="box-shadow box-equal p-2">
                  <div className="work_sustain snackspot">
                    <img src="./assets/images/icon/vending-machine.png" style={{ width: '33px' }} alt="" />
                    <p className="sustain_new">Snack Spot</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">Stacked with a full selection of our favorite retail
                    items available in our grab-scan-go shelves.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="swin-sc swin-sc-contact-form light mtl">&nbsp;</div>
          </div>
        </div>
      </section>
    </>
  );
}
